import { careerJourney, skillCategories } from '../../data/skills';
import { ui } from '../../data/ui';
import { SectionHeader } from '../ui/SectionHeader';
import { SkillCard } from '../ui/SkillCard';
import { ScrollReveal } from '../ui/ScrollReveal';
import './Skills.css';

export function Skills() {
  return (
    <section className="section skills-section bg-grid" id="skills">
      <div className="container">
        <SectionHeader
          label={ui.sections.expertise}
          title={ui.sections.technologySkills}
          subtitle={ui.sections.technologySkillsSub}
        />

        <ScrollReveal className="career-journey">
          <p className="journey-label">{ui.sections.careerProgression}</p>
          <div className="journey-track">
            {careerJourney.map((step, i) => (
              <div key={step} className="journey-step">
                <span className={`journey-dot ${i === careerJourney.length - 1 ? 'journey-dot-current' : ''}`} />
                <span className={`journey-text ${i === careerJourney.length - 1 ? 'journey-text-current' : ''}`}>
                  {step}
                </span>
                {i < careerJourney.length - 1 && <span className="journey-arrow">←</span>}
              </div>
            ))}
          </div>
        </ScrollReveal>

        <div className="skills-grid">
          {skillCategories.map((category, i) => (
            <SkillCard key={category.id} category={category} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
